// extracted by mini-css-extract-plugin
export default {"avatar-flex":"avatar_avatar-flex__7yCeW","avatar-wrapper":"avatar_avatar-wrapper__0q8C-"};